import React from 'react';
import PropTypes from 'prop-types';

import ManagedInput from 'components/form/managed_input';
import OptionLayout from './option_layout';

export default function SimpleOption({ defaults, option, onRemove, onUpdate }) {
  return (
    <OptionLayout
      isOverridden={defaults.hasOwnProperty(option.name)}
      label={option.label}
      onRemove={() => onRemove([option.name])}
      onReset={() => onUpdate({ [option.name]: false })}
    >
      <ManagedInput
        inline={false}
        inputClassName="form-check-input"
        name={option.name}
        options={[
          { label: 'On', value: true },
          { label: 'Off', value: false },
        ]}
        type="radioGroup"
        value={defaults[option.name]}
        onValueChange={value => onUpdate({ [option.name]: value === 'true' })}
      />
    </OptionLayout>
  );
}

SimpleOption.propTypes = {
  defaults: PropTypes.object.isRequired,
  option: PropTypes.shape({
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  onRemove: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
};
